// Builds the full, shareable referral URL for a code. Signups that land on
// the signup route with this `?ref=<code>` get attributed to the link. Kept in
// one place so the generate modal and the list row produce identical URLs.
export function referralLinkUrl(code: string): string {
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  return `${origin}/auth/signup?ref=${encodeURIComponent(code)}`;
}

// Leader join links share the same attribution machinery but land visitors on
// the group's page instead of the signup form (the group's normal join policy
// still applies). Shared by the leader card, its create modal, and the admin
// referral-links table so all three render the same URL for a group-scoped code.
export function groupJoinLinkUrl(code: string): string {
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  return `${origin}/join/${encodeURIComponent(code)}`;
}
